import DOMPurify from 'dompurify';

export function sanitizeHtml(dirty) {
    return DOMPurify.sanitize(dirty ?? '', {
        ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 's', 'ul', 'ol', 'li', 'h3', 'h4', 'h5', 'blockquote', 'a'],
        ALLOWED_ATTR: ['href', 'target', 'rel']
    });
}

export function getUsernameInitials(sentName) {
    let initials = '';
    let parts = sentName.length > 0 ? sentName.split(' ') : [sentName];
    let finalParts = parts.filter((part) => part.length > 0 && part !== '');
    let total = Math.min(2, finalParts.length);
    for (let i = 0; i < total; i++) {
        initials += finalParts[i][0].toUpperCase();
    }
    return initials;
}

// export function simpleDate(date, showTime = false) {
//     if (!(date instanceof Date) || isNaN(date)) {
//         console.log('Invalid date provided to formatDateForDisplay:', date);
//         return 'Invalid Date'; // Or any other appropriate fallback
//     }

//     const day = date.getDate();
//     const year = date.getFullYear();

//     // Array of month abbreviations
//     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//     const month = monthNames[date.getMonth()];

//     // return `${day} ${month}, ${year}`;
//     let formatted = `${day} ${month}, ${year}`;

//     if (showTime) {
//         const hours = String(date.getHours()).padStart(2, '0');
//         const minutes = String(date.getMinutes()).padStart(2, '0');
//         formatted += ` ${hours}:${minutes}`;
//     }

//     return formatted;
// }

export function simpleDate(value, showTime = false) {
    // console.log('simpleDate input value:', value);
    // Convert Firestore Timestamp / Timestamp-like -> Date
    const date =
        value instanceof Date
            ? value
            : value?.toDate
            ? value.toDate()
            : typeof value?.seconds === 'number'
            ? new Date(value.seconds * 1000 + Math.floor((value.nanoseconds || 0) / 1e6))
            : typeof value?._seconds === 'number'
            ? new Date(value._seconds * 1000 + Math.floor((value._nanoseconds || 0) / 1e6))
            : null;

    if (!(date instanceof Date) || isNaN(date.getTime())) {
        // console.log('Invalid date provided to simpleDate:', value);
        return '';
    }

    const day = date.getDate();
    const year = date.getFullYear();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let formatted = `${day} ${monthNames[date.getMonth()]}, ${year}`;

    if (showTime) {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        formatted += ` ${hours}:${minutes}`;
    }

    return formatted;
}
//

export function dateFromTimestamp(ts, includeTime = true) {
    if (!ts) return '';

    try {
        const date =
            ts instanceof Date
                ? ts
                : typeof ts?.toDate === 'function'
                ? ts.toDate()
                : typeof ts === 'string'
                ? new Date(ts)
                : typeof ts === 'number'
                ? // treat < 1e12 as seconds, otherwise ms
                  new Date(ts < 1e12 ? ts * 1000 : ts)
                : ts && typeof ts.seconds === 'number'
                ? // Firestore JSON: { seconds, nanoseconds }
                  new Date(ts.seconds * 1000 + (ts.nanoseconds || 0) / 1e6)
                : null;

        if (!date || isNaN(date)) return '';

        const datePart = date.toLocaleDateString('en-AU', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });

        const timePart = date
            .toLocaleTimeString('en-AU', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            })
            .replace(' ', '')
            .toLowerCase(); // 12:35pm

        const suffix = includeTime ? ` (${timePart})` : '';

        return `${datePart}${suffix}`;
    } catch {
        return '';
    }
}

// export function sameDate(d1, d2) {
//     if (!d1 || !d2) return false;

//     return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
// }

// export function formatDate(date) {
//     if (!date) return '';
//     if (this.sameDate(date, new Date())) return 'Today';

//     var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
//     return date.toLocaleDateString('en-US', options);
// }

export function parseFirestoreDate(value) {
    if (!value) return null;

    // Firestore Timestamp instance
    if (typeof value.toDate === 'function') {
        const d = value.toDate();
        return isNaN(d.getTime()) ? null : d;
    }

    // { seconds, nanoseconds }
    if (typeof value === 'object' && 'seconds' in value) {
        const ms = value.seconds * 1000 + Math.floor((value.nanoseconds || 0) / 1e6);
        const d = new Date(ms);
        return isNaN(d.getTime()) ? null : d;
    }

    // Number (seconds or milliseconds)
    if (typeof value === 'number') {
        const ms = value < 1e12 ? value * 1000 : value; // assume seconds if too small
        const d = new Date(ms);
        return isNaN(d.getTime()) ? null : d;
    }

    // String (ISO or Date-parsable)
    if (typeof value === 'string') {
        const d = new Date(value);
        return isNaN(d.getTime()) ? null : d;
    }

    // Already a Date
    if (value instanceof Date) {
        return isNaN(value.getTime()) ? null : value;
    }

    return null;
}
